import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, A11y, Autoplay, EffectFade } from "swiper/modules";

function HeroSlider() {
    const heroCards = [
        {
            id: 1,
            content: (
                <div className="card card-1 h-100">
                    <div className="card-body h-100">
                        <div className="row mx-0 h-100">
                            <div className="col-md-6 px-0 h-100 d-flex align-items-start justify-content-end flex-column">
                                <div className="Heading">Trading for Anyone. Anywhere. Anytime.</div>
                                <p>Trade over 1000 Instruments. Forex, CFDs on Stock Indices, Commodities, Stocks, Metals and Energies.</p>
                            </div>
                        </div>
                    </div>
                </div>
            )
        },
        {
            id: 2,
            content: (
                <div className="card card-2">
                    <div className="card-body">
                        <div className="row mx-0 h-100">
                            <div className="col-md-8 h-100 d-flex align-items-start justify-content-center flex-column">
                                <div className="Heading">Learn, Practice & Succeed in Forex</div>
                                <p>Understanding the basics, using demo accounts, and learning risk management is key to becoming a successful Forex trader.</p>
                            </div>
                        </div>
                    </div>
                </div>
            )
        },
        {
            id: 3,
            content: (
                <div className="card card-3">
                    <div className="card-body">
                        <div className="row mx-0 h-100">
                            <div className="col-md-8 h-100 d-flex align-items-start justify-content-center flex-column">
                                <div className="Heading">Global Market, Local Access</div>
                                <p>Trade major currency pairs from anywhere using a smartphone or laptop with just an internet connection.</p>
                            </div>
                        </div>
                    </div>
                </div>
            )
        },
    ];

    return (
        <Swiper
        modules={[Navigation, Pagination, A11y, Autoplay, EffectFade]}
        navigation
        pagination={{ clickable: true }}
        spaceBetween={0}
        slidesPerView={1}
        loop={true}
        effect="fade"
        autoplay={{
            delay: 9000,
            disableOnInteraction: false,
        }}
        speed={1000}
    >
        {heroCards.map((item) => (
            <SwiperSlide key={item.id}>
                {item.content}
            </SwiperSlide>
        ))}
    </Swiper>
    );
}

export default HeroSlider;
